/**
 * [ File :: G_GraphicGrid.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/lcCanvasGrid/dev/child/graphic/G_GraphicGrid.js
 * @목적 : 그래픽 그리드 객체 생성을 위한 클래스
 * @설명 : "그래픽 클래스"와 "그리드 클래스"를 다중 상속 받습니다.
 * @진행 : 종료
 * @주의 : 없음
 * @일자 : 2018.02.27
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Real       from 'canvas/base/dev/child/base/B_Real';
import B_ChildWorld from 'canvas/base/dev/child/base/B_ChildWorld';
import B_Grahpic    from 'canvas/base/dev/child/graphic/B_Grahpic';
import B_GridChild  from 'canvas/base/dev/child/grid/B_GridChild';
import G_GridChild  from 'canvas/grid/dev/child/grid/G_GridChild';
import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';

let mix = (superclass) => new MixinBuilder(superclass);

const G_GraphicGrid = (function() {

	return class extends mix(B_Real).with(B_ChildWorld, B_Grahpic, B_GridChild, G_GridChild) {
		constructor(obj) { super(obj); }
	}
}());

export default G_GraphicGrid;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/graphic/G_GraphicGrid.js